var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiBookClockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 11.26V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h5.11c1.26 1.24 2.98 2 4.89 2c3.87 0 7-3.13 7-7c0-2.38-1.19-4.47-3-5.74M18 4v6.29c-.63-.18-1.3-.29-2-.29c-1.07 0-2.09.25-3 .68V4zM6 4h2v8l2.5-2.25l1.6 1.44A7 7 0 0 0 9 17c0 1.08.25 2.09.68 3H6zm10 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 18v-5h1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBookClockOutline);
export default __webpack_public_path__ + "static/media/mdi--book-clock-outline.af35e1dfc67bacb689b7e1bc7b31df3f.svg";
export { ForwardRef as ReactComponent };